<script setup lang="ts">
import { useGlobalSalaryPeriod } from '~/composables/useGlobalSalaryPeriod'

const { activePeriod, changePeriod } = useGlobalSalaryPeriod()
const periods = ['hourly', 'weekly', 'biweekly', 'monthly', 'annually']
const periodLabels = {
  hourly: { short: 'Hr', full: 'Hourly' },
  weekly: { short: 'Wk', full: 'Weekly' },
  biweekly: { short: 'Bi-Wk', full: 'Biweekly' },
  monthly: { short: 'Mo', full: 'Monthly' },
  annually: { short: 'Yr', full: 'Annually' }
}
function handlePeriodChange(period: string) {
  changePeriod(period)
}
</script>

<template>
  <div class="flex w-full">
    <button
      v-for="(period, index) in periods"
      :key="period"
      :class="[
        activePeriod === period
          ? 'bg-primary-100 text-primary-600 font-medium'
          : 'bg-gray-50 text-gray-600 hover:bg-gray-100',
        'flex-1 transition-all duration-200',
        'py-2 xs:py-3 sm:py-4 md:py-5',
        index === 0 ? 'rounded-tl-lg' : '',
        index === periods.length - 1 ? 'rounded-tr-lg' : '',
        'border-b-2',
        activePeriod === period ? 'border-primary-500' : 'border-transparent'
      ]"
      @click="handlePeriodChange(period)"
    >
      <span class="text-xs sm:text-sm md:hidden">
        {{ periodLabels[period].short }}
      </span>
      <span class="hidden md:inline text-sm">
        {{ periodLabels[period].full }}
      </span>
    </button>
  </div>
</template>

<style scoped>
@media (max-width: 370px) {
  button {
    padding-left: 2px;
    padding-right: 2px;
  }
}
</style>
